import React from 'react';
import { Switch } from 'react-router';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { APP_ROUTES, IRoute } from '../../../routing/AppRoutes';
import { BaseRoute } from 'src/routing/BaseRoute';
import { CreateGuestTabs } from '../../../features/user/common/createGuest/CreateGuestTabs';
import { GuestsLayout } from '../../../features/user/expert/guests/GuestsLayout';

const useStyles = makeStyles(() => ({
  tabsWrapper: {
    margin: '0 0 20px',
  },
}));

type PNewContacts = {
  routes: Array<IRoute>;
};

export const CreateNewGuestLayout: React.FC<PNewContacts> = (props) => {
  const { routes } = props;
  const classes = useStyles();
  return (
    <GuestsLayout
      title="NEW Guest"
      description="Guest you add here are only visible to you"
    >
      <div className={classes.tabsWrapper}>
        <CreateGuestTabs
          creationOfGuestPath={APP_ROUTES.CREATE_GUEST}
          uploadingOfGuestPath={APP_ROUTES.FN_UPLOAD_GUEST_MEDIA()}
        />
      </div>

      <Switch>
        {routes.map((route) => (
          <BaseRoute {...route} key={route.path} />
        ))}
      </Switch>
    </GuestsLayout>
  );
};
